import React, { FC } from 'react';

import Rive, { Fit, Layout } from '@rive-app/react-canvas';

import styles from './styles.module.scss';

const FullscreenPreloader: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.animation}>
        <Rive
          layout={
            new Layout({
              fit: Fit.Cover,
            })
          }
          shouldResizeCanvasToContainer
          src="/animations/loader.riv"
        />
      </div>
    </div>
  );
};

export default FullscreenPreloader;
